import ContractAdmin from "./ContractAdmin-container";

/**
 * Export the top level component ContractAdmin-container
 *
 * @version 0.0.1
 * @author Steve Hunley
 *
 */
export default ContractAdmin;
